module.exports = __webpack_public_path__ + "img/info.ef1d45e8.svg";